/**
 * Name: Slider
 */

import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import Component from "@lunaweb/vega-reactor-js/src/patterns/Component";

export default class Slider extends Component {

  static settings = {};

  #swiper;
  #container;
  #itemsElement;
  #items;
  #pagination;
  #next;
  #prev;

  constructor (element, options = {}) {
    super(element, {
      ...Slider.settings,
      ...options
    });

    this.#container = this.element.querySelector('.js-slider-container');
    this.#itemsElement = this.element.querySelector('.js-slider-items');
    this.#items = this.element.querySelectorAll('.js-slider-item');
    this.#prev = this.element.querySelector('.js-slider-prev');
    this.#next = this.element.querySelector('.js-slider-next');
    this.#pagination = this.element.querySelector('.js-slider-pagination');
  }

  update () {
    const items = this.#swiper ? this.#swiper.slides : this.#items;
    const currentIndex = this.#swiper ? this.#swiper.activeIndex : 0;

    items.forEach((element, index) => {
      if (index === currentIndex) {
        element.removeAttribute('aria-hidden');
      } else {
        element.setAttribute('aria-hidden', "true");
      }
    });

    if (this.#swiper?.isBeginning) {
      this.#prev.removeAttribute('disabled');
      this.#prev.removeAttribute('tabindex');
    }

    if (this.#swiper?.isEnd) {
      this.#next.removeAttribute('disabled');
      this.#next.removeAttribute('tabindex');
    }
  }

  mount () {
    this.update();

    this.#swiper = new Swiper(this.#container, {
      modules: [Navigation, Pagination, A11y],
      loop: true,
      a11y: {
        enable: true,
        itemRoleDescriptionMessage: "slide",
        firstSlideMessage: "Premier élément",
        lastSlideMessage: "Dernier élément",
        nextSlideMessage: "Élement suivant",
        prevSlideMessage: "Élement précédent",
        slideLabelMessage: '{{index}} sur {{slidesLength}}',
      },
      navigation: {
        nextEl: this.#next,
        prevEl: this.#prev,
      },
      pagination: {
        el: this.#pagination,
        type: "fraction",
      },
      on: {
        slideChange: () => {
          this.update();
        },
      }
    });

    this.#itemsElement.setAttribute('aria-atomic', "true");

    super.mount();
  }

  unmount () {
    this.#swiper.destroy();
    this.#itemsElement.removeAttribute('aria-atomic');

    super.unmount();
  }
}
